import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const ClientsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.listClientsPage,
      component: React.lazy(() => import('./ClientsApp')),
      exact: true,
    },
    {
      path: routesUrl.clientsDetailPage,
      component: React.lazy(() => import('./ClientDetailPage')),
    },
  ],
};

export default ClientsAppConfig;
